import { AxiosResponse } from "axios"
import ConnectApi from "../../baseService"
import { TApiResponse } from "../../TApiResponse"
import { TGinkoKozaListGetReq, TGinkoKozaListGetRes } from "./TGinkoKoza"

/**
 * 銀行口座マスタに対するAPIリクエスト用サービス
 *
 * @export
 * @class GinkoKozaService
 * @extends {ConnectApi}
 */
export default class GinkoKozaService extends ConnectApi {
  /**
   * 検索取得
   *
   * @param {TMenuInfoGetReq} params
   * @memberof MenuService
   */
  getList = async (params?: TGinkoKozaListGetReq) => {
    try {
      const res: AxiosResponse<TApiResponse<TGinkoKozaListGetRes>> =
        await this.getInner(`/master/ginkokoza`, params)
      return res.data
    } catch (error) {
      throw error
    }
  }
}
